import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CommonHelper, ProfileEntity } from '@meplis/common';
import { Router } from '@angular/router';
import { environment } from '@meplis/environments';
import { AppRoutes } from '../../../constants/app-routes.constant';
import { AuthenticationService } from '../../../services/application/authentication.service';
import {
  i18nService,
  ModalService,
  ProfileService,
  ToastService,
} from '@meplis/services';
import { MatMenuModule } from '@angular/material/menu';
import { ProfileAvatarComponent } from '../profile-avatar/profile-avatar.component';
import { InviteCodeModalComponent } from '../invite-code-modal/invite-code-modal.component';

@Component({
  selector: 'app-profile-widget',
  imports: [
    CommonModule,
    TranslateModule,
    MatMenuModule,
    ProfileAvatarComponent,
  ],
  templateUrl: './profile-widget.component.html',
  styleUrls: ['./profile-widget.component.scss'],
})
export class ProfileWidgetComponent implements OnInit, OnDestroy {
  public accountUrl: string;
  public imageAvatarUrl: string;
  public profile: ProfileEntity;

  public subscription: Subscription;
  public appRoutes = AppRoutes;

  constructor(
    public _router: Router,
    private _authService: AuthenticationService,
    private _i18nService: i18nService,
    private _profileService: ProfileService,
    private _toastService: ToastService,
    private _modalService: ModalService
  ) {
    this.subscription = this._authService.onLoggedInOut.subscribe(() => {
      this._handleInitialization();
    });
  }

  public ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  public async ngOnInit(): Promise<void> {
    this._handleInitialization();
  }

  public async _handleInitialization(): Promise<void> {
    if (!this._authService.isLogged) {
      return;
    }

    this.profile = await this._profileService.getProfile();
    this.imageAvatarUrl = CommonHelper.getAvatarImage(this.profile.id);

    const socialUrl = environment.social;
    const language = this._i18nService.language;
    const profileId = this.profile.id;

    this.accountUrl = `${socialUrl}/${language}/profiles/${profileId}`;
  }

  public openModalInviteCode(): void {
    this._modalService.openModal(InviteCodeModalComponent);
  }

  public goToPage(path: string): void {
    this._router.navigate([path]);
  }

  public logout(): void {
    const logoutResult = this._authService.logOut(AppRoutes['LOGIN'].fullPath);
    if (logoutResult) {
      this._toastService.showSuccess('AUT.FEEDBACK.OPEN.LOGOUT.200.SUCCESS');
    }
  }
}
